import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../app_components/StandardModal'
import NotificationItem from './NotificationItem'
class NotificationSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      notifications: [],
      points_notification: [],
      badge_notification: []
    }

    this.renderNotifications = this.renderNotifications.bind(this)
    this.deleteNotification = this.deleteNotification.bind(this)
    this.deleteBadgeNotification = this.deleteBadgeNotification.bind(this)
    this.getNotifications = this.getNotifications.bind(this)
    this.notificationCount = this.notificationCount.bind(this)
    this.updateCount = this.updateCount.bind(this)
  }

  componentDidMount() {
    this.getNotifications()
  }

  notificationCount() {
    return this.state.notifications.length
      + this.state.points_notification.length
      + this.state.badge_notification.length
  }

  updateCount() {
    if (this.props.onCountChange) {
      this.props.onCountChange(this.notificationCount())
    }
  }

  deleteNotification(id) {
    const data = {
      id: id
    }
    $.ajax({
      url: `../delete_notification`,
      dataType: 'JSON',
      type: 'DELETE',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          notifications: data.data.notifications,
          points_notification: data.data.points_notification,
          badge_notification: JSON.parse(data.data.badge_notification)
        }, this.updateCount)
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  getNotifications() {
    $.ajax({
      url: `../get_user_notifications`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          notifications: data.data.notifications,
          points_notification: data.data.points_notification,
          badge_notification: JSON.parse(data.data.badge_notification)
        }, this.updateCount)
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  deleteBadgeNotification(id) {
    const data = {
      id: id
    }
    $.ajax({
      url: `../onboard_badge`,
      dataType: 'JSON',
      type: 'POST',
      data: data,
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.getNotifications()
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  renderNotifications() {
    if(this.state.notifications.length > 0) {
      return this.state.notifications.map((not, i) => {
        return  (
          <NotificationItem
            notification={not}
            key={not.id || i}
            closeIcon={this.props.closeIcon}
            onClick={this.deleteNotification}
          />
        )
      })
    }
    return (
      <p className="notification-modal__empty">All caught up!</p>
    )
  }

  renderContent() {
    return (
      <div className="notification-modal">
        <div className="notification-modal__list user-notifications">
          {this.renderNotifications()}
        </div>
      </div>
    )
  }

  render() {
    if (this.props.inModal) {
      return (
        <>
          {this.props.isOpen &&
            <StandardModal
              onClose={this.props.onClose}
              title="Notifications"
              size="wide"
            >
              {this.renderContent()}
            </StandardModal>
          }
        </>
      )
    }

    return(
      <div className="matches_wrapper padding_page">
        <h4 className="sectionHeader" style={{textAlign: 'left'}}>Notifications</h4>
        {this.renderContent()}
      </div>
    )
  }

}

NotificationSection.propTypes = {
  inModal: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onCountChange: PropTypes.func,
  confettiLottie: PropTypes.string,
  lexicoin: PropTypes.string,
  closeIcon: PropTypes.string,
}

export default NotificationSection
